import { JOIN_TYPE_ENUM } from '@/constants/common'
import { JOIN_FORM_DATA } from '@/constants/storage'
import Storage from '@/utils/storage'
import { getMapToArray } from '@/utils/utils'

//城市合伙人入驻流程步骤
export const CITY_PARTNER_STEP = Object.freeze({
  BASIC_INFO: {
    id: 0,
    title: '完善基本信息',
  },
  REBATE_ACCOUNT_INFO: {
    id: 1,
    title: '返佣账号信息',
  },
  PAYMENT_INFO: {
    id: 2,
    title: '付款信息确认',
  },
  SIGN_AGREEMENT: {
    id: 3,
    title: '协议签署',
  },
  SUCCESS: {
    id: 4,
    title: '入驻成功',
  },
})
export const CITY_PARTNER_STEP_ARRAY = getMapToArray(CITY_PARTNER_STEP)
//反佣大使入驻流程步骤
export const AMBASSADOR_STEP = Object.freeze({
  BASIC_INFO: {
    id: 0,
    title: '完善基本信息',
  },
  REBATE_ACCOUNT_INFO: {
    id: 1,
    title: '返佣账号信息',
  },
  SIGN_AGREEMENT: {
    id: 2,
    title: '协议签署',
  },
  SUCCESS: {
    id: 3,
    title: '入驻成功',
  },
})
export const AMBASSADOR_STEP_ARRAY = getMapToArray(AMBASSADOR_STEP)
//步骤流程枚举集合
export const JOIN_STEP_MAP = Object.freeze({
  [JOIN_TYPE_ENUM.CITY_PARTNER.value]: CITY_PARTNER_STEP,
  [JOIN_TYPE_ENUM.AMBASSADOR.value]: AMBASSADOR_STEP,
})
//加盟入驻节点状态枚举
// 0-待提交资料，10-已提交待付款 11-待付款已取消  20-已付款待审核， 21-已审核被驳回 ，22-被驳回已取消 30-已审核待签署  31-已发起签署 32-签署过期 33-拒签 40-成功
export const JOIN_STATUS = Object.freeze({
  WAIT_SUBMIT: 0, //待提交资料
  WAIT_PAY: 10, //已提交待付款
  PAY_CANCEL: 11, //待付款已取消
  WAIT_AUDIT: 20, //已付款待审核
  AUDIT_REJECT: 21, //已审核被驳回
  REJECT_CANCEL: 22, //被驳回已取消
  WAIT_SIGN: 30, //已审核待签署
  SIGN_START: 31, //已发起签署
  SIGN_EXPIRED: 32, //签署过期
  REJECT_SIGN: 33, //拒签
  SUCCESS: 40, //成功
})

//加盟入驻步骤状态
export const STEP_STATUS = Object.freeze({
  NOT_SUBMIT: 0, //未提交
  PROCESS: 1, //签约中
  ERROR: 2, //失败
  FINISH: 3, //成功
})

// //加盟入驻步骤
// export const JOIN_STEP = Object.freeze({
//   BASIC_INFO: 0, //基本信息
//   REBATE_ACCOUNT_INFO: 1, //返佣账号信息
//   PAYMENT_INFO: 2, //付款信息确认
//   SIGN_AGREEMENT: 3, //协议签署
//   SUCCESS: 4, //入驻成功
// })

//加盟入驻表单数据本地缓存操作
export const JOIN_LOCAL = {
  // 设置加盟入驻表单数据本地缓存
  setJoinFormData(obj) {
    const { userInfo } = Storage.get('user') || {}

    if (!userInfo?.uid) {
      return
    }
    let temp = Storage.get(JOIN_FORM_DATA) || {}
    temp[userInfo?.uid] = Object.assign(temp[userInfo?.uid] || {}, obj)
    Storage.set(JOIN_FORM_DATA, temp)
  },

  // 获取加盟入驻表单数据本地缓存
  getJoinFormData() {
    const obj = Storage.get(JOIN_FORM_DATA)
    const { userInfo } = Storage.get('user') || {}
    if (!userInfo?.uid) {
      return
    }
    return (obj && obj[userInfo?.uid]) || ''
  },

  // 删除加盟入驻表单数据本地缓存
  removeJoinFormData() {
    const obj = Storage.get(JOIN_FORM_DATA)
    const { userInfo } = Storage.get('user') || {}
    if (!userInfo?.uid) {
      return
    }
    delete obj[userInfo?.uid]
    Storage.set(JOIN_FORM_DATA, obj)
  },
}

//OCR识别数据处理
export const identifyEmpty = (obj) => {
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      if (obj[key] === '--' || obj[key] === '无') {
        obj[key] = ''
      }
    }
  }
}

/**
 * 只合并非 null 和非 undefined 的值到目标对象
 * @param {Object} target 目标对象
 * @param {...Object} sources 源对象列表
 * @returns {Object} 合并后的目标对象
 */
export const assignNonNullValues = (target, ...sources) => {
  sources.forEach((source) => {
    if (source && typeof source === 'object') {
      Object.keys(source).forEach((key) => {
        if (source[key] !== null && source[key] !== undefined && source[key] !== '') {
          target[key] = source[key]
        }
      })
    }
  })
  return target
}
